/* icconX help assistant engine (Phase 1 v2, 13 Oct 2026; 15 Oct: warranty check through the order lookup). Welcome screen → chat. Renders the scripted flows from
   icconx-assistant-flows.js, hands the support form to icconx-assistant-form.js and order lookup to
   icconx-assistant-track.js. The header always shows "Active now" (the assistant answers instantly); human reply
   times and support hours are told inside the Talk to support flow. Keeps the ids BoatSupportTrigger /
   BoatSupportModal / BoatSupportClose and opens from any [data-icconx-help] element. */
(function () {
  var cfgEl = document.getElementById('IxaConfig'), panel = document.getElementById('BoatSupportModal');
  if (!cfgEl || !panel || !window.IXA_FLOWS || !window.IXA_FORM || !window.IXA_TRACK) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var oEl = document.getElementById('IxaOrders'); cfg.orders = oEl ? JSON.parse(oEl.textContent) : [];
  var markT = document.getElementById('IxaMark'); cfg.mark = markT ? markT.innerHTML : '';
  var $ = function (id) { return document.getElementById(id); };
  var log = $('IxaLog'), back = $('IxaBack'), trigger = $('BoatSupportTrigger'), backdrop = $('IxaBackdrop'), welcome = $('IxaWelcome'), chat = $('IxaChat'), startB = $('IxaStart'), newB = $('IxaNew');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ctx = {}, opener = null, busy = false, started = false;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /* Support hours in IST (Mon-Sat 10 AM-6 PM, holidays and festive flag from the config) feed the reply-time wording. */
  function ist(d) {
    var o = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday), hour: parseInt(o.hour, 10) % 24, date: o.year + '-' + o.month + '-' + o.day };
  }
  function working(t) { return cfg.holidays.indexOf(t.date) < 0 && (cfg.festive || t.day !== 0); }
  function setStatus() {
    var t = ist(new Date()), wd = working(t);
    cfg.online = wd && t.hour >= 10 && t.hour < 18;
    cfg.nextDay = '';
    if (!wd) { var n = Date.now(); for (var i = 1; i < 8; i++) { var x = ist(new Date(n + i * 864e5)); if (working(x)) { cfg.nextDay = DAYS[x.day]; break; } } }
  }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function scroll() { log.scrollTop = log.scrollHeight; }
  function bot(html) { var r = el('div', 'ixa-row'); r.appendChild(el('div', 'ixa-av', cfg.mark)); r.appendChild(el('div', 'ixa-b ixa-b--bot', html)); log.appendChild(r); scroll(); }
  function user(text) { var r = el('div', 'ixa-row ixa-row--u'); r.appendChild(el('div', 'ixa-b ixa-b--u', esc(text))); log.appendChild(r); scroll(); }
  function typing(ms) {
    return new Promise(function (res) {
      if (reduce) return res();
      var r = el('div', 'ixa-row'); r.appendChild(el('div', 'ixa-av', cfg.mark)); r.appendChild(el('div', 'ixa-b ixa-b--bot ixa-typing', '<i></i><i></i><i></i>'));
      log.appendChild(r); scroll(); setTimeout(function () { r.remove(); res(); }, ms);
    });
  }
  function settle() { log.querySelectorAll('.ixa-opts:not(.is-done)').forEach(function (x) { x.classList.add('is-done'); x.querySelectorAll('button').forEach(function (b) { b.disabled = true; }); }); }

  var A = { cfg: cfg, ctx: ctx, el: el, esc: esc, log: log, scroll: scroll, bot: bot, user: user, typing: typing, ist: ist, go: go, chips: function (opts) { renderOptions({ kind: 'chips', options: opts }); } };
  var FL = window.IXA_FLOWS(cfg, ctx), FORM = window.IXA_FORM(A), TRACK = window.IXA_TRACK(A, FORM);

  async function go(id, label) {
    if (busy) return; busy = true;
    settle(); if (label) user(label);
    var step = typeof FL[id] === 'function' ? FL[id]() : FL[id];
    back.hidden = id === 'home';
    var msgs = [].concat(step.bot || []);
    for (var i = 0; i < msgs.length; i++) { await typing(i ? 350 : 450); bot(msgs[i]); }
    if (step.orders) renderOrders(step.orders);
    if (step.order) TRACK.card(step.order);
    if (step.lookup) TRACK.render(step.lookup === 'warranty' ? 'warranty' : 'track');
    if (step.warranty) TRACK.warranty(step.warranty);
    if (step.form) FORM.render(step.form);
    if (step.options) renderOptions(step);
    if (step.more) renderOptions(step.more);
    busy = false;
  }
  function renderOptions(step) {
    var box = el('div', 'ixa-opts' + (step.kind === 'cards' ? ' ixa-opts--cards' : step.kind === 'buttons' ? ' ixa-opts--buttons' : ''));
    step.options.forEach(function (o) {
      var b;
      if (o.href) { b = el('a', 'ixa-btn ' + (o.primary ? 'ixa-btn--p' : 'ixa-btn--s'), esc(o.t)); b.href = o.href; }
      else if (step.kind === 'cards') { b = el('button', 'ixa-card', '<span class="ixa-card__ic">' + o.icon + '</span><span class="ixa-card__t">' + esc(o.t) + '</span><span class="ixa-card__s">' + esc(o.s) + '</span>'); }
      else { b = el('button', step.kind === 'buttons' ? 'ixa-btn ' + (o.primary ? 'ixa-btn--p' : 'ixa-btn--s') : 'ixa-chip', esc(o.t)); }
      if (!o.href) { b.type = 'button'; b.addEventListener('click', function () { if (o.set) Object.assign(ctx, o.set); if (o.go === 'home') reset(); else go(o.go, o.t); }); }
      box.appendChild(b);
    });
    log.appendChild(box); scroll();
  }
  function renderOrders(orders) {
    var box = el('div', 'ixa-opts ixa-opts--buttons');
    orders.forEach(function (o) {
      var c = el('div', 'ixa-order', '<div class="ixa-order__n"><span>' + esc(o.name) + '</span><span class="ixa-pill ' + (o.cancelled ? 'ixa-pill--no' : /fulfilled/i.test(o.status) && !/un|partial/i.test(o.status) ? 'ixa-pill--ok' : 'ixa-pill--go') + '">' + esc(o.cancelled ? 'Cancelled' : o.status) + '</span></div><div class="ixa-order__m">' + esc(o.date) + ' · ' + esc(o.items) + '</div>');
      var row = el('div', 'ixa-order__a');
      if (o.tracking) { var t = el('a', 'ixa-btn ixa-btn--p', 'Track shipment'); t.href = o.tracking; t.target = '_blank'; t.rel = 'noopener'; row.appendChild(t); }
      var v = el('a', 'ixa-btn ixa-btn--s', 'View order'); v.href = o.url; row.appendChild(v);
      var h = el('button', 'ixa-btn ixa-btn--s', 'Need help'); h.type = 'button'; h.addEventListener('click', function () { ctx.order = o.name; ctx.issue = 'Order status'; go('form', 'Need help with ' + o.name); }); row.appendChild(h);
      c.appendChild(row); box.appendChild(c);
    });
    log.appendChild(box); scroll();
  }

  /* Screens: welcome → chat. Reopening during a conversation returns to the chat; the welcome card then offers
     "Continue conversation" plus "Start a new conversation". */
  function showWelcome() {
    welcome.hidden = false; chat.hidden = true;
    startB.textContent = started ? 'Continue conversation' : 'Start conversation';
    newB.hidden = !started;
  }
  function showChat(fresh) {
    welcome.hidden = true; chat.hidden = false;
    if (fresh || !started) { started = true; log.innerHTML = ''; for (var k in ctx) delete ctx[k]; busy = false; go('home'); }
    setTimeout(function () { $('BoatSupportClose').focus({ preventScroll: true }); scroll(); }, 80);
  }
  function reset() { log.innerHTML = ''; for (var k in ctx) delete ctx[k]; busy = false; go('home'); }
  function isOpen() { return panel.classList.contains('is-open'); }
  function open(from) {
    opener = from || trigger; setStatus();
    panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); backdrop.classList.add('is-on'); document.body.classList.add('ixa-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    showWelcome();
    setTimeout(function () { startB.focus({ preventScroll: true }); }, 80);
  }
  function close() {
    panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); backdrop.classList.remove('is-on'); document.body.classList.remove('ixa-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (opener && opener.focus) opener.focus({ preventScroll: true }); opener = null;
  }

  /* Phone bottom sheet (owner, 13 Oct): the grab handle is a real control. Tap it to minimise, or pull the sheet down
     with a finger; past 90px it closes, otherwise it springs back. */
  function sheet(area) {
    if (!area) return;
    var grab = el('button', 'ixa-grab'); grab.type = 'button'; grab.setAttribute('aria-label', 'Minimise chat'); area.appendChild(grab);
    grab.addEventListener('click', close);
    var y0 = null, dy = 0;
    area.addEventListener('touchstart', function (e) { if (window.innerWidth > 749) return; y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
    area.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    area.addEventListener('touchend', function () { if (y0 === null) return; panel.style.transition = ''; panel.style.transform = ''; if (dy > 90) close(); y0 = null; });
  }
  sheet(document.querySelector('.ixa-welcome__hero')); sheet(document.querySelector('.ixa-head'));

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-icconx-help], #BoatSupportTrigger');
    if (!t) return;
    e.preventDefault();
    if (isOpen()) close(); else open(t);
  });
  startB.addEventListener('click', function () { showChat(false); });
  newB.addEventListener('click', function () { showChat(true); });
  $('BoatSupportClose').addEventListener('click', close);
  $('IxaCloseW').addEventListener('click', close);
  backdrop.addEventListener('click', close);
  back.addEventListener('click', reset);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  setStatus(); setInterval(setStatus, 60000);
})();
